import { IAppParams } from "../models";
import { safe } from "./";
import { FRONT_END_CLIENT_TYPES } from "../../config";
import * as url from "url";

export function getAppParams(rootElement) {
    let appParams = Object.keys(rootElement.attributes).reduce((existing, key) => {
        existing[rootElement.attributes[key].name] = safe(() => {
            if (rootElement.attributes[key].name === "isin") {
                return rootElement.attributes[key].value.toUpperCase();
            } else {
               return rootElement.attributes[key].value
            }
        }, null);
        return existing;
    }, {}) as IAppParams;

    if (appParams.region) {
        appParams.region = appParams.region.toLowerCase();
    }

    if (appParams.clienttype) {
        let { clienttype } = appParams;
        clienttype = clienttype.toLowerCase();
        let adjustedClientType = safe(() => FRONT_END_CLIENT_TYPES.filter(c => c.code.toLowerCase() === clienttype || c.text.toLowerCase() === clienttype)[0], null);
        if (adjustedClientType) {
            appParams.clienttype = adjustedClientType.code;
        }
    }
    // DEBUG ONLY UNTIL PRODUCT RANGE IMPLEMENTED
    if (!appParams.productrange) {
        appParams.productrange = 'OEIC';
    }
    appParams._location = url.parse(window.location.href, true);
    return appParams;
}


// WEBPACK FOOTER //
// ./src/client/utils/appParams.ts